const convertDate = (date: string) => {
    return new Date(date).toLocaleString('en-US', {month: "long", year: "numeric"});
};

export default convertDate;